/** FloorForce's build of the Broadstreet ad loader, as dealers embed it in their CMS scripts. */
export const BROADSTREET_INIT_SCRIPT_SRC =
  'https://static.floorforce.com/init-2.min.js';

/**
 * Origins that serve the network and zone scripts once the loader runs. Each zone in the
 * hero waits on a request to them.
 */
export const BROADSTREET_AD_ORIGINS = [
  'https://sponsors.floorforce.com',
  'https://sponsors-v2.floorforce.com',
];
